
import About from '../components/About';
import Ceo from '../components/Ceo';
import Staff from '../components/Staff';


export default function Home() {
    return (
        <div className="bg-custom-light-orange">
            <About />
            <Ceo />
            <Staff />
        </div>
    )
}